import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import dayjs from "dayjs";
import Icon from "../icon/Icon";
import { CashCanceled, CashCharge, CashUsed, Sizes } from "../icon/IconList";
const CashTransactionItem = (param)=>{
    let { transaction  } = param;
    const { orderTitle , status , totalAmount , firstCreatedAt  } = transaction;
    const displayIcon = ()=>{
        switch(status){
            case "CHARGE":
                return CashCharge;
            case "USE":
                return CashUsed;
            default:
                return CashCanceled;
        }
    };
    const displayStatusText = ()=>{
        switch(status){
            case "CHARGE":
                return "캐시 충전";
            case "USE":
                return "상품 결제";
            case "RESTORE":
                return "상품 결제 취소";
            case "REFUND":
                return "캐시 충전 취소";
            case "EXPIRE":
                return "캐시 만료";
        }
    };
    const displayAmountText = ()=>{
        switch(status){
            case "CHARGE":
            case "RESTORE":
                return "+".concat(totalAmount.toLocaleString(), "원");
            case "REFUND":
            case "EXPIRE":
            case "USE":
                return "".concat(totalAmount.toLocaleString(), "원");
        }
    };
    const displayAmountColor = ()=>{
        switch(status){
            case "CHARGE":
            case "RESTORE":
                return "text-mint-400";
            default:
                return "text-primary";
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex p-4 gap-3 border-b border-gray-100",
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                icon: displayIcon(),
                size: Sizes.large
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-1",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "text-primary",
                                        children: displayStatusText()
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: displayAmountColor(),
                                        children: displayAmountText()
                                    })
                                ]
                            }),
                            orderTitle && /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-primary",
                                children: orderTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "body2",
                            className: "text-secondary",
                            children: dayjs(firstCreatedAt).format("YYYY.MM.DD HH:mm")
                        })
                    })
                ]
            })
        ]
    });
};
export default CashTransactionItem;
